<template>
  <div>
    <div v-if="loadingOverlay === true">{{loadingOverlayText}}</div>
    <div v-if="profileData !== null">
      <div class="alert alert-dismissible fade show" :class="alertType" v-if="displayAlert==true">
        <button
          type="button"
          aria-hidden="true"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
          @click="displayAlert = false">
          <i class="nc-icon nc-simple-remove"></i>
        </button>
        <span>{{alertMsg}}</span>
      </div>

      <h4 class="subheading grey--text">Update Profile Details</h4>

      <div class="card">
        <div style="padding: 25px;">

          <div class="row justify-content-center">
            <div class="picture-container">
              <el-upload class="picture" action="https://jsonplaceholder.typicode.com/posts/" 
                :on-change="handlePreview" :auto-upload="false" :show-file-list="false">
                <img :src="photo.imageUrl" class="picture-src">
              </el-upload>
              <h6 class="description">Choose Profile Photo</h6>
            </div>
          </div>

          <form ref="newClientForm">
            <fg-input
              label="First Name"
              v-model="model.firstName"
              v-validate="modelValidations.firstName"
              name="firstName"
              type="text"
              :error="getError('firstName')"
              required
            ></fg-input>
            <fg-input
              label="Last Name"
              v-model="model.lastName"
              v-validate="modelValidations.lastName"
              name="lastName"
              type="text"
              :error="getError('lastName')"
              required
            ></fg-input>
            <fg-input
              label="City"
              v-model="model.city"
              v-validate="modelValidations.city"
              name="City"
              type="text"
              :error="getError('city')"
              required
            ></fg-input>
            <fg-input
              label="State"
              v-model="model.state"
              v-validate="modelValidations.state"
              name="state"
              type="text"
              :error="getError('state')"
              required
            ></fg-input>
            <fg-input
              label="Country"
              v-model="model.country"
              v-validate="modelValidations.country"
              name="country"
              type="text"
              :error="getError('country')"
              required
            ></fg-input>

            <p-button color="info" class="mr-4" type="submit" @click="onSubmit">SAVE PROFILE</p-button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- <v-content v-if="profileData !== null">
    <v-overlay v-if="savingOverlay === true">Saving Profile...</v-overlay>
    <v-overlay v-if="loadingOverlay === true">Loading Profile...</v-overlay>
    <v-container>
      <v-alert :value="displayAlert" :color="alertType">{{alertMsg}}</v-alert>
      <h1 class="subheading grey--text">My Profile</h1>
      <v-form @submit="onSubmit" ref="form">
        <v-text-field label="First Name" solo v-model="profileData.firstName" :rules="fNameRules" required></v-text-field>
        <v-text-field label="Last Name" solo v-model="profileData.lastName" :rules="lNameRules" required></v-text-field>
        <v-text-field label="Company" solo v-model="profileData.company" ></v-text-field>
        <v-text-field label="City" solo v-model="profileData.city" :rules="cityRules" required></v-text-field>
        <v-text-field label="State" solo v-model="profileData.state"></v-text-field>
        <v-text-field label="Country" solo v-model="profileData.country"></v-text-field>
        <v-btn color="success" class="mr-4" type="submit">SAVE PROFILE</v-btn>
      </v-form>
    </v-container>
  </v-content>-->
</template>
<script>
import firebase from "firebase";
import { mapGetters, mapActions } from "vuex";
import store from "@/store/index.js";
import axios from "axios";
import {Upload} from 'element-ui';
import { config } from '@/config/s3-bucket'
// import IGProfileData from "../libs/ig/profileData";
import {
  userUpdateApi,
  // igCheckApi,
  userLoadApi
} from "@/config/appSettings.js";
export default {
  name: "Profile",
  components: {
    [Upload.name]: Upload
  },
  data: () => ({
    auth: null,
    savingOverlay: false,
    loadingOverlay: false,
    loadingOverlayText: false,
    valid: true,
    firstName: null,
    lastName: null,
    fNameRules: [v => !!v || "First name is required"],
    lNameRules: [v => !!v || "Last name is required"],
    email: "",
    company: null,
    profileData: null,
    state: "",
    states: [],
    country: "",
    countries: [],
    city: "",
    paypal: "",
    cityRules: [v => !!v || "City is required"],
    companyRules: [v => !!v || "Company name is required"],
    alertMsg: "",
    alertType: "",
    displayAlert: false,
    model: {
      firstName: "",
      lastName: "",
      city: null,
      zip: null,
      country: null,
      state: null,
      region: ""
    },
    photo: {
      imageUrl: config.s3Url + '/profile/' + firebase.auth().currentUser.uid + '.png' + '?update=' + new Date()
    },
    modelValidations: {
      firstName: {
        required: true
      },
      lastName: {
        required: true
      }
    }
  }),
  computed: mapGetters(["profileStore"]),
  created() {
    this.profileData = this.profileStore;
    //console.log("PROFILE STORE IN CREATED:", this.profileStore);
  },
  methods: {
    ...mapActions(["updateProfile", "loadProfile"]),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
       // console.log("CHECKING IS VALID:", isValid);
       // console.log("CHECKING REGISTER FORM: ", this.registerForm);
        this.$emit("on-submit", this.registerForm, isValid);
      });
    },

    async directLoadProfile() {
      this.loadingOverlay = true;
      //console.log("SHOWING MODAL")
      // profileInfo from store state

      //console.log("LOADED PROFILE DATA", this.profileData);
      if (this.profileData !== false) {
        this.model.firstName = this.profileData.firstName;
        this.model.lastName = this.profileData.lastName;
        this.model.city = this.profileData.city;
        this.model.state = this.profileData.state;
        this.model.country = this.profileData.country;
        this.company = this.profileData.companyName;
        this.loadingOverlay = false;
        return;
      }
      let profileLoadResponse = await axios.get(`${userLoadApi}${this.auth}`);
      //console.log("PROFILE DATA MAIN FROM NAV:", profileLoadResponse.data);
      if (profileLoadResponse.data.success == true) {
        this.profileData = profileLoadResponse.data.result;
        this.model.firstName = this.profileData.firstName;
        this.model.lastName = this.profileData.lastName;
        this.model.city = this.profileData.city;
        this.model.state = this.profileData.state;
        this.model.country = this.profileData.country;
        this.company = this.profileData.companyName;
        this.loadingOverlay = false;
      }
      //console.log("PROFILE DATA:", this.profileData);

      // this.closeLoadingModal();
    },
    async onSubmit(e) {
      e.preventDefault();
      this.displayAlert = false;
      this.savingOverlay = true;

      try {
        let self = this;

        let validateCheck = await this.$validator.validateAll();
        //console.log("VALIDATING:", validateCheck);
        if (validateCheck == true) {
          //console.log("INSIDE UPDATING ");
          let formInfo = {};
          formInfo.first_name = this.model.firstName;
          formInfo.last_name = this.model.lastName;
          formInfo.city = this.model.city;
          formInfo.state = this.model.state;
          formInfo.country = this.model.country;
          formInfo.email = this.email;
          formInfo.company_name = this.company;
          formInfo.usertoken = firebase.auth().currentUser.uid;
          let updateProfileResponse = await axios.post(userUpdateApi, formInfo);
          //console.log("USER UPDATE RESPONSE:", updateProfileResponse.data);

          if (updateProfileResponse.data.success === true) {
            self.savingOverlay = false;
            self.alertType = "alert-success";
            self.alertMsg = "Profile Updated Successfully.";
            self.displayAlert = true;
            let updatedProfile = {};
            updatedProfile.firstName = this.model.firstName;
            updatedProfile.lastName = this.model.lastName;
            updatedProfile.city = this.model.city;
            updatedProfile.state = this.model.state;
            updatedProfile.country = this.model.country;
            updatedProfile.email = this.email;
            updatedProfile.company_name = this.company;
            store.dispatch("updateProfile", updatedProfile);
            document.body.scrollTop = document.documentElement.scrollTop = 0;
          } else {
            //console.log("THERE WAS AN ERROR:");
            self.savingOverlay = false;
            self.alertType = "alert-danger";
            self.alertMsg = "Please check all fields.";
            self.displayAlert = true;
            document.body.scrollTop = document.documentElement.scrollTop = 0;
          }
        } else {
          //console.log("THERE WAS AN ERROR", err);
          self.savingOverlay = false;
          self.alertType = "alert-danger";
          self.alertMsg = "Please check all fields.";
          self.displayAlert = true;
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR", err);
        self.savingOverlay = false;
        self.alertType = "alert-danger";
        self.alertMsg = "Please check all fields.";
        self.displayAlert = true;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
    },

    closeLoadingModal() {
      let self = this;

      setTimeout(function() {
        self.loadingOverlay = false;
      }, 100);
    },

    openLoadingModal() {},

    handlePreview(file) {
      const data = this
      store.dispatch("saveUserProfilePhoto", file).then((response) => {
        data.photo.imageUrl = response.location + '?update=' + new Date()
        data.alertType = "alert-success";
        data.alertMsg = "Profile Photo Updated Successfully.";
        data.displayAlert = true;
      })
    },
  },
  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.email = firebase.auth().currentUser.email;
    this.directLoadProfile();
  }
};
</script>

<style lang="scss">
  .picture-container .picture {
    input[type="file"] {
      display: none;
    }
  }

  .picture {
    width: 130px;
    height: 130px;
    background-color: #999999;
    border: 1px solid #E3E3E3;
    color: #FFFFFF;
    border-radius: 50%;
    margin: 5px auto;
    overflow: hidden;
  }

  .picture-src {
    height: 180px;
    width: 180px;
    object-fit: cover;
  }
  
</style>